export enum ExpeditionStatus {
  OPEN = 'Open',
  READY = 'Ready',
  ONGOING = 'Ongoing',
  CLOSED = 'Closed',
  INCOMPLETED = 'Incomplete',
  DELETED = 'Deleted',
}

export enum ExpeditionStatusGroup {
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
}

export enum UpdateExpeditionStatus {
  OPEN = 'Open',
  OPEN_AND_READY = 'OpenAndReady',
  ALL = 'All',
}